import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    height: '100vh',
  },
});

export default useStyles;
